import { useEffect, useState } from 'react'
import { useAuth } from 'react-oidc-context'
import { Alert, Card, CircularProgress, Grid, Typography } from '@mui/material'

import useStyles from '../../components/auth/index.styles'
import LoginFooter from '../../components/login-footer'
import loginWaves from '../../images/login-waves.svg'
import meshifyLogo from '../../images/meshify-central-logo.svg'
import useSharedStyles from '../../utils/shared.styles'

// this was not correctly working from localhost, but works fine in dev
// so if any changes to this flow are needed in future
// it is better to test on preview urls or in dev
const Invite = () => {
  const auth = useAuth()
  const classes = useStyles
  const sharedClasses = useSharedStyles

  const [error, setError] = useState<string | null>(null)
  const [isRedirecting, setIsRedirecting] = useState(false)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)

    // Handle OIDC error params returned from MeshifyAuth
    const oidcError = params.get('error')
    const oidcErrorDescription = params.get('error_description')
    if (oidcError) {
      setError(oidcErrorDescription ?? oidcError)
      return
    }

    const inviteToken = params.get('inviteToken')

    if (!inviteToken) {
      setError('Invalid or missing invite token. Please use the link from your invitation email.')
      return
    }

    const initiateInvite = async () => {
      setIsRedirecting(true)
      try {
        await auth.signinRedirect({
          login_hint: 'invite',
          extraQueryParams: { inviteToken },
        })
      } catch (err) {
        setIsRedirecting(false)
        setError(err instanceof Error ? err.message : 'An unexpected error occurred. Please try again or contact support.')
      }
    }

    initiateInvite()
  }, [auth])

  return (
    <>
      <img src={loginWaves} alt="" style={classes.loginWaves} />
      <Grid container={true} sx={[sharedClasses.centerContent, classes.loginContainer]}>
        <Grid>
          <Card sx={classes.loginCard}>
            <Grid container={true} sx={[sharedClasses.centerContentHorizontal, { gap: '24px' }]}>
              <Grid container={true} sx={[sharedClasses.centerContentHorizontal, sharedClasses.fullWidth]}>
                <img src={meshifyLogo} alt="Meshify logo" style={classes.logo} aria-label="Logo" />
              </Grid>

              {error ? (
                <>
                  <Grid container={true} sx={[sharedClasses.centerContentHorizontal, sharedClasses.fullWidth]}>
                    <Typography variant="h4">Invitation Error</Typography>
                  </Grid>

                  <Grid container={true} sx={sharedClasses.fullWidth}>
                    <Alert severity="error" sx={sharedClasses.fullWidth}>
                      {error}
                    </Alert>
                  </Grid>
                </>
              ) : (
                <>
                  <Grid container={true} sx={[sharedClasses.centerContentHorizontal, sharedClasses.fullWidth]}>
                    <Typography variant="h4">Just a Moment</Typography>
                  </Grid>

                  <Grid container={true} sx={[sharedClasses.centerContentHorizontal, sharedClasses.fullWidth]}>
                    <Typography variant="body1">We are setting up your account…</Typography>
                  </Grid>

                  {isRedirecting && (
                    <Grid container={true} sx={[sharedClasses.centerContentHorizontal, sharedClasses.fullWidth]}>
                      <CircularProgress size={32} />
                    </Grid>
                  )}
                </>
              )}
            </Grid>
          </Card>
        </Grid>

        <LoginFooter />
      </Grid>
    </>
  )
}

export default Invite
